const layout = {
  en: {
    teacherBadge: "Teacher",
    nav: {
      myStudents: "My students",
      atRisk: "At risk",
      metrics: "Metrics",
      qa: "Q&A",
      support: "Support",
      supportShort: "Support",
    },
    // Shell: rail, top bar, phone drawer and tab bar
    more: "More",
    mainNav: "Main navigation",
    teacherNav: "Teacher navigation",
    quickNav: "Quick navigation",
    breadcrumb: "Breadcrumb",
    profileMenu: "Profile menu",
    userFallback: "User",
    themeLight: "Light",
    themeDark: "Dark",
    unread: "{count} new notifications",
  },
  ru: {
    teacherBadge: "Учитель",
    nav: {
      myStudents: "Мои студенты",
      atRisk: "В зоне риска",
      metrics: "Метрики",
      qa: "Вопросы и ответы",
      support: "Поддержка",
      supportShort: "Поддержка",
    },
    // Shell: rail, top bar, phone drawer and tab bar
    more: "Ещё",
    mainNav: "Основное меню",
    teacherNav: "Меню учителя",
    quickNav: "Быстрое меню",
    breadcrumb: "Путь к странице",
    profileMenu: "Меню профиля",
    userFallback: "Пользователь",
    themeLight: "Светлая",
    themeDark: "Тёмная",
    unread: "Новых уведомлений: {count}",
  },
  uz: {
    teacherBadge: "O'qituvchi",
    nav: {
      myStudents: "Mening o'quvchilarim",
      atRisk: "Xavf ostida",
      metrics: "Ko'rsatkichlar",
      qa: "Savol-javob",
      support: "Qo'llab-quvvatlash",
      supportShort: "Yordam",
    },
    // Shell: rail, top bar, phone drawer and tab bar
    more: "Ko'proq",
    mainNav: "Asosiy menyu",
    teacherNav: "O'qituvchi menyusi",
    quickNav: "Tezkor menyu",
    breadcrumb: "Sahifa yo'li",
    profileMenu: "Profil menyusi",
    userFallback: "Foydalanuvchi",
    themeLight: "Kun rejimi",
    themeDark: "Tun rejimi",
    unread: "{count} ta yangi bildirishnoma",
  },
};

export default layout;
